// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"757": "1e51a57114391042","972": "45d7f8981418779a",}[chunkId] + ".css"
}